import { AdminClientAnketasDownload } from "./AdminClientAnketasDownload"

export default AdminClientAnketasDownload;